import createFetchClient from 'openapi-fetch'
import createClient from 'openapi-react-query'

import type { paths } from '../gen/tintin-ticket-service-schema'
import config from './req.config'

export type { paths as TicketPaths }

export const ticketServiceReq = createFetchClient<paths>({
  ...config,
})

export const ticketServiceQuery = createClient<paths>(ticketServiceReq)
